export const companiesQueryKeys = {
  all: ['companies'] as const,
  lists: () => [...companiesQueryKeys.all, 'list'] as const,
  list: (filters: object) => [...companiesQueryKeys.lists(), filters] as const,
  details: () => [...companiesQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...companiesQueryKeys.details(), id] as const,
};
